import React from 'react'
import { Navigate } from 'react-router-dom'
import ViewMarketPage from '@/pages/market-page'
// const ViewBetInfo = lazy(() => import('@/pages/bet-info'))

export default [
  { path: '/q/feed', element: <Navigate to="/" replace /> },
  { path: '/bet/:predictionId/info', element: <Navigate to="/" replace /> },

  {
    path: ['/q/:questionId', '/q/:questionId/:questionSlug'],
    element: <ViewMarketPage />,
  },
  {
    path: '/q/',
    element: <Navigate to="/" replace />,
  },
]
